import type { ReactElement } from 'react';
import type IAiChatToolHeader from '../interfaces/IAiChatToolHeader';

import styles from '../sass/AiChat.module.scss';

/** The line every tool call opens with: the tool, and beside it what the call is doing. */
function AiChatToolHeader({ name, status }: IAiChatToolHeader): ReactElement {
  return (
    <div className={styles.toolHeader}>
      <p className={styles.toolName}>{name}</p>
      {status ? <p className={styles.toolStatus}>{status}</p> : null}
    </div>
  );
}

export default AiChatToolHeader;
